<template>
    <a-modal
        :width="'60%'"
        v-model="deviceTypeFlag"
        title="新增设备型号"
        :maskClosable="maskClosable"
        @ok="handleOk">
        <div style="padding:20px;background-color: #f0f2f5">
            <a-card>
                <a-form :form="form">
                    <a-form-item label='设备图片' v-bind="formItemLayout">
                        <!-- <a-input size="small"  v-decorator="['name',{ rules: [{ required: true, message: '请输入型号名称!' },{ validator: hasSpecialChar}] }]"></a-input> -->
                        <!-- <UploadImage v-decorator="['image',{ rules: [{ required: true, message: '请上传图片！' }] }]"  /> -->
                        <UploadImage @uploadComplete="uploadComplete" v-model="modelImage"  />
                    </a-form-item>

                    <a-form-item label='型号名称' v-bind="formItemLayout">
                        <a-input size="small"  v-decorator="['name',{ rules: [{ required: true, message: '请输入型号名称!' },{ validator: hasSpecialChar}] }]"></a-input>
                    </a-form-item>

                    <a-form-item label='支持有线' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['wired',{ rules: [{ required: true, message: '请选择是否支持有线!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label='支持GPS' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityGps',{ rules: [{ required: true, message: '请选择是否支持GPS!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label='支持LBS' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityLbs',{ rules: [{ required: true, message: '请选择是否支持LBS!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>


                    <a-form-item label='支持WIFI' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityWifi',{ rules: [{ required: true, message: '请选择是否支持WIFI!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label='支持蓝牙' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityBluetooth',{ rules: [{ required: true, message: '请选择是否支持蓝牙!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label='支持计步' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityStep',{ rules: [{ required: true, message: '请选择是否支持计步!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label='支持电子锁' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityElock',{ rules: [{ required: true, message: '请选择是否支持电子锁!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label='支持开锁检测' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityLockDetect',{ rules: [{ required: true, message: '请选择是否支持开锁检测!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label='支持心率' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityHeartrate',{ rules: [{ required: true, message: '请选择是否支持计步!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                      <a-form-item label='支持血压' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityBloodPressure',{ rules: [{ required: true, message: '请选择是否支持血压!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>


                      <a-form-item label='支持血氧' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityBloodOxygen',{ rules: [{ required: true, message: '请选择是否支持血氧!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                      <a-form-item label='支持温度' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['capbilityTemperature',{ rules: [{ required: true, message: '请选择是否支持温度!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>


                    <a-form-item label='支持充值' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['rechargeable',{ rules: [{ required: true, message: '请选择是否支持充值!' }] }]">
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label='设备制式' v-bind="formItemLayout">
                        <a-select  size="small" v-decorator="['correspondStandard',{ rules: [{ required: true, message: '请选择设备制式!' }] }]">
                          <template v-for="(item, index) in standards">
                            <a-select-option :key="index" :value="item">{{item}}</a-select-option>
                          </template>
                        </a-select>
                    </a-form-item>

                    
                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import {hasSpecialChar} from '../../utils/formFunctions'
    import UploadImage from '../../components/common/UploadImage'
    import {httpModel} from '../../http/httpModel'
    export default {
        name: 'ZDeviceType',
        components: {
          UploadImage
        },
        data() {
            return {
                modelImage: '',
                deviceTypeFlag: false,
                maskClosable: false,
                name: null,
                form: null,
                id: null,
                standards: [],
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    }
                }
            }
        },
        created () {
          this.getDeviceStandard()
        },
        methods: {
            hasSpecialChar,
            uploadComplete (img) {
              console.log(img)
            },
            // 获取设备制式
            getDeviceStandard () {
              httpModel.getDeviceStandard().then((res) => {
                // console.log(res)
                this.standards = res
              })
            },
            showModel(model){
                if(model){
                    this.id = model.id
                }else{
                    this.id = null
                }
                this.form = this.$form.createForm(this)
                this.deviceTypeFlag = true
                this.$nextTick().then(() => {
                    this.form.setFieldsValue({
                        name: model ? model.name : ''
                    });
                    this.form.setFieldsValue({
                        wired: model ? model.wired : '1'
                    });
                    this.form.setFieldsValue({
                        capbilityGps: model ? model.capbilityGps :  '1'
                    });
                    this.form.setFieldsValue({
                        capbilityLbs: model ? model.capbilityLbs :  '1'
                    });
                    this.form.setFieldsValue({
                        capbilityWifi: model ? model.capbilityWifi :  '1'
                    });
                    this.form.setFieldsValue({
                        capbilityBluetooth: model ? model.capbilityBluetooth :  '1'
                    });
                    this.form.setFieldsValue({
                        capbilityStep: model ? model.capbilityStep :  '1'
                    });
                    this.form.setFieldsValue({
                        capbilityElock: model ? model.capbilityElock :  '1',
                        capbilityLockDetect: model ? model.capbilityLockDetect :  '1',
                    });
                    this.form.setFieldsValue({
                        capbilityHeartrate: model ? model.capbilityHeartrate :  '1'
                    });
                    this.form.setFieldsValue({
                        capbilityBloodPressure: model ? model.capbilityBloodPressure :  '1'
                    });
                    this.form.setFieldsValue({
                        capbilityBloodOxygen: model ? model.capbilityBloodOxygen :  '1'
                    });
                    this.form.setFieldsValue({
                        capbilityTemperature: model ? model.capbilityTemperature :  '1'
                    });
                    this.form.setFieldsValue({
                        rechargeable: model ? model.rechargeable :  '1',
                        correspondStandard: model.correspondStandard || ''
                    });
                    this.form.setFieldsValue({
                        imgUrl: model ? model.image :  '',
                    });
                    this.modelImage = model ? model.image :  ''
                })
            },
            handleOk(){
                this.form.validateFieldsAndScroll((err,values) => {
                    // console.log(values)
                    if(!err){
                        let model = values
                        model.id = this.id
                        model.wired = model.wired == '1' ? true : false
                        model.capbilityGps = model.capbilityGps == '1' ? true : false
                        model.capbilityLbs = model.capbilityLbs == '1' ? true : false
                        model.capbilityWifi = model.capbilityWifi == '1' ? true : false
                        model.capbilityBluetooth = model.capbilityBluetooth == '1' ? true : false
                        model.capbilityStep =  model.capbilityStep == '1' ? true : false
                        model.capbilityElock = model.capbilityElock == '1' ? true : false
                        model.capbilityLockDetect = model.capbilityLockDetect == '1' ? true : false
                        model.capbilityHeartrate = model.capbilityHeartrate == '1' ? true : false
                        model.capbilityBloodPressure = model.capbilityBloodPressure == '1' ? true : false
                        model.capbilityBloodOxygen = model.capbilityBloodOxygen == '1' ? true : false
                        model.capbilityTemperature = model.capbilityTemperature == '1' ? true : false
                        model.rechargeable = model.rechargeable == '1' ? true : false
                        model.image = this.modelImage || ''

                        if(model.id){
                            this.$http.put(config.api.device_types_url,model).then((response) => {
                                if(response.code == 0){
                                    this.deviceTypeFlag = false
                                    this.$notification.success({
                                      message: '操作成功'
                                    })
                                    this.$emit("refresh")
                                } else {
                                  this.deviceTypeFlag = false
                                    this.$notification.error({
                                      message: response.desc
                                    })
                                    this.$emit("refresh")
                                }
                            }).catch((err) => {
                                console.log(err)
                            })
                        }else{
                            this.$http.post(config.api.device_types_url,model).then((response) => {
                                if(response.code == 0){
                                    this.deviceTypeFlag = false
                                    this.$message.success('操作成功')
                                    this.$emit("refresh")
                                }
                            }).catch((err) => {
                                console.log(err)
                            })
                        }
                    }
                })
            }
        }
    }
</script>